import posthog from "posthog-js";

export const isFeatureFlagEnabled = name => {
  posthog.reloadFeatureFlags();
  return posthog.isFeatureEnabled(name);
};

export const identify = userId => {
  posthog.identify(userId, {
    name: userId
  });
};

export const FEATURE_FLAG = {
  REVIEWS_SHOW_REPLY_TEMPLATES: "show-reviews-reply-templates",
  SERVICE_UNAVAILABLE: "service-unavailable",
  GET_UNVERIFIED_FACILITIES: "get-unverified-facilities",
  SHOW_REVIEW_BOOSTER: "show-review-booster",
  SHOW_REVIEW_BOOSTER_PROMO: "show-review-booster-promo",
  SHOW_EDIT_FACILITY_FROM_FILE: "show-edit-facility-from-file",
  SHOW_INTEGRATIONS: "show-integrations",
  SHOW_RB_CATEGORIES: "show-rb-categories",
  SHOW_CONVERSION_CHARTS: "show-conversion-charts",
  SHOW_FACEBOOK_INTEGRATION: "show-facebook-integration",
  SHOW_RB_CATEGORIES_ANALYTICS: "show-rb-categories-analytics",
  SHOW_REVIEW_ADDED_WITH_RB: "show-review-added-with-rb",
  CN_5335_BING_MAPS_LINK: "CN-5335_bing-maps-link",
  SHOW_DASHBOARD_INCREASE_INDICATOR:
    "CN-5587-dashboard-show-increase-indicators",
  SHOW_APPS_CONFIG_PAGE: "CN-5651_google_play_account",
  CN_5721_SERVICES: "CN-5721_services",
  CN_5810_INTERCOM_INTEGRATION: "CN-5810_intercom-integration",
  CN_5906_FILTER_BING_STATUS: "CN-5906_filter-bing-status",
  SHOW_SERVICE_ITEMS_EXTERNAL_CHANGES: "show-service-items-external-changes",
  SHOW_STORE_LOCATOR_EXTRA_INFO: "show-store-locator-extra-info",
  CN_6145_FACILITIES_QUALITY: "CN-6145_facilities_quality",
  CN_6363_LIMITS_DELETION: "CN-6363_limits_deletion",
  CN_6392_MASS_SERVICES_MANAGING: "CN-6392_mass-services-managing",
  CN_6531_SPANISH_TRANSLATIONS: "CN-6531_spanish-translations",
  CN_6543_QUESTIONS_AND_ANSWERS: "CN-6543_questions-and-answers",
  CN_6573_FAQ_STORE_LOCATOR: "CN-6573_faq-store-locator",
  CN_6637_COPY_FACEBOOK_POSTS: "CN-6637_copy-facebook-posts",
  CN_6665_AUTO_REVIEW_REPLY: "CN-6665_auto-review-reply",
  CN_5526_APPLE_MAPS: "CN-5526_apple-maps",
  CN_6968_BULK_ASSIGN_CATEGORIES_FOR_REPLIED_REVIEWS:
    "CN-6968_bulk-assign-categories-for-replied-reviews"
};
